export var flexPositions = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end'
};